/* eslint-disable no-unused-vars */
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { creativesActions } from 'store/actions';
import * as S from './LastItem.styled';
import { Tab, DropDownWrapper, Each, Search, Separator } from 'components';
import { TabContent } from '../tabContent/TabContent';
import { Search as SmallSearchIcon } from 'assets/icons';
import { DropDownItem } from '../dropDownItem/DropDownItem';
import { useSignal, useComputed } from '@preact/signals-react';
import { isEqual } from 'lodash-es';
import { usePrevious } from 'utils';

const tabStyle = {
  maxWidth: '21%',
  minWidth: '21%',
  width: '21%',
  height: '70px',
  textAlign: 'left',
  paddingTop: '4px',
};

export const LastItem = ({
  separateCreatives$,
  selectedBannerId,
  handleCreativeChange,
  disabledBtn$,
}) => {
  const selectedBannerId$ = useSignal(selectedBannerId);

  useEffect(() => {
    selectedBannerId$.value = selectedBannerId;
  }, [selectedBannerId]);

  const firstElement$ = useSignal(separateCreatives$.value.otherElements[0]);
  const otherElements$ = useSignal(
    separateCreatives$.value.otherElements.slice(1, separateCreatives$.value.otherElements.length),
  );

  const previousCreativesList = usePrevious(separateCreatives$.value.otherElements);

  useEffect(() => {
    if (!isEqual(previousCreativesList, separateCreatives$.value.otherElements)) {
      firstElement$.value = separateCreatives$.value.otherElements[0];
      otherElements$.value = separateCreatives$.value.otherElements.slice(
        1,
        separateCreatives$.value.otherElements.length,
      );
    }
  }, [separateCreatives$.value.otherElements]);

  const btnRef = useRef(null);
  const searchRef = useRef(null);

  const searchValue$ = useSignal('');
  const dispatch = useDispatch();
  const dropDownIsOpen$ = useSignal(false);

  const filteredItems$ = useComputed(() => {
    if (!searchValue$.value) return otherElements$.value;
    return otherElements$.value.filter(({ name, bn_bannerid }) => {
      if (name.includes(searchValue$.value)) return true;
      if (bn_bannerid.toString().includes(searchValue$.value)) return true;
      return false;
    });
  });

  const handleClickOnOtherElements = (bn_bannerid) => {
    handleCreativeChange(bn_bannerid);
    const firstElement = separateCreatives$.value.otherElements.find(
      (item) => item.bn_bannerid === bn_bannerid,
    );
    const otherElements = separateCreatives$.value.otherElements.filter(
      (item) => item.bn_bannerid !== bn_bannerid,
    );
    dispatch(creativesActions.changeOrderNextThreeCreative([firstElement, ...otherElements]));
    firstElement$.value = firstElement;
    otherElements$.value = otherElements;
  };

  return (
    <>
      {useComputed(() => (
        <Tab
          pressed={selectedBannerId$.value === firstElement$.value.bn_bannerid}
          label={
            <TabContent
              {...firstElement$.value}
              showDropDownBtn={separateCreatives$.value.otherElements.length > 1}
              btnPressed$={dropDownIsOpen$}
              btnRef={btnRef}
              searchValue$={searchValue$}
              disabledBtn$={disabledBtn$}
            />
          }
          onChange={() => handleCreativeChange(firstElement$.value.bn_bannerid)}
          style={tabStyle}
        />
      ))}
      {useComputed(() => (
        <div style={{ position: 'relative' }}>
          {dropDownIsOpen$.value && (
            <DropDownWrapper
              isOpen$={dropDownIsOpen$}
              width={300}
              targetRef={btnRef}
              style={{
                top: '80px',
                right: '0px',
              }}
              outSideClickAction={() => {}}
            >
              <Search
                ref={searchRef}
                id='creativeSearch'
                onChange={(e) => (searchValue$.value = e.target.value)}
                value={searchValue$?.value}
                placeholder='Search'
                rightIconOnClick={() => (searchValue$.value = '')}
                Icon={SmallSearchIcon}
                style={{ marginBottom: '4px' }}
              />

              <Separator width='calc(100% + 16px)' marginLeft={-8} />

              <S.ListContainer>
                {
                  <Each
                    fieldOfIndex='bn_bannerid'
                    of={filteredItems$.value}
                    render={(item, index) => {
                      return (
                        <DropDownItem
                          {...item}
                          searchValue$={searchValue$}
                          handleCreativeChange={handleClickOnOtherElements}
                          dropDownIsOpen$={dropDownIsOpen$}
                        />
                      );
                    }}
                  />
                }
              </S.ListContainer>
            </DropDownWrapper>
          )}
        </div>
      ))}
    </>
  );
};
